import React, { Fragment, useContext, useEffect, useState } from 'react';
import { ActionButton, DocumentCard, DocumentCardActions, DocumentCardActivity, DocumentCardLocation, DocumentCardPreview, DocumentCardTitle, Dropdown, IDropdownOption, Icon, IconButton, Panel, PanelType, PrimaryButton, SelectableOptionMenuItemType, Text, TextField, TooltipHost } from 'office-ui-fabric-react';

import { WsDeliverConfigResourceItem, WsDeliverConfigSchemaItem, WsDeliverConfigSchemaMapping } from '../../../../../core/src/interfaces';

import { WsDeliverConfigItemType, WsDeliverConfigSchemaMappingStatus, WsDeliverConfigWorkload } from '../../../enums';

import { apiGet, apiPost } from '../../../helpers-sales';

import Loading from '../../Shared/Loading';

import { WsDeliverActionSelect } from '../Config/ConfigActionSelect';

import { getConfigItemType, getParentPath } from "../data/deliver-data";

import { WsConfigDataType } from "./ConfigPage";
import { getSchemaMappingList, getSchemaMappingStatus, getSchemaMappingStatusName, resourceTypeIsResource, sortMappingList } from "../data/mapping-data";




import './ConfigPage.scss';
import './ConfigTenant.scss';
import { useHistory, useParams } from "react-router-dom";
import { WsDeliverPortalContext } from "../DeliverPortalContext";
import { BiCommentDetail } from "react-icons/bi";




const newResources: WsDeliverConfigSchemaItem[] = [
  {
    name: "CallRecording/callId",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
  {
    name: "CallRecording/contentCorrelationId",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
  {
    name: "CallRecording/endDateTime",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
  {
    name: "CallTranscript/callId",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
  {
    name: "CallTranscript/contentCorrelationId",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
  {
    name: "CallTranscript/endDateTime",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
  
  
  
  
  
  {
    name: "PhotoUpdateSettings/photoUpdateSettings",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
  {
    name: "PhotoUpdateSettings/photoUpdateSettings",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
  {
    name: "PhotoUpdateSettings/photoUpdateSettings",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
  {
    name: "PeopleAdminSettings/list",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
  {
    name: "PeopleAdminSettings/create",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
  {
    name: "PeopleAdminSettings/delete",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
  
  
  {
    name: "ApplicationTemplate/configurationUri",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
  {
    name: "ApplicationTemplate/configurationUri",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
  {
    name: "ApplicationTemplate/configurationUri",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
  
  {
    name: "CallRecording/MeetingOrganizerId",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
  {
    name: "CallTranscript/MeetingOrganizerId",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
  {
    name: "CompanyDetail/CompanyCode",
    id: '', schemaPath: '', workload: WsDeliverConfigWorkload.NotSet, type: WsDeliverConfigItemType.String
  },
];




const newSources: any[] = [
  { name: 'Microsoft Graph Changelog', workload: 'Teams', when: 'August 30, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=3c1cbe3b-c55a-4ab6-a055-53af1db155b0', description: 'Added the clientAppId property to the teamsAppAuthorization resource.' },

  { name: 'Microsoft Graph Changelog', workload: 'Exchange', when: 'August 23, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=db94e9ef-db0f-4872-8093-41852c5b07e5', description: 'Added the permanentDelete method to the mailFolder resource.' },
  { name: 'Microsoft Graph Changelog', workload: 'Exchange', when: 'August 23, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=db94e9ef-db0f-4872-8093-41852c5b07e5', description: 'Added the permanentDelete method to the message resource.' },
  { name: 'Microsoft Graph Changelog', workload: 'Exchange', when: 'August 23, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=db94e9ef-db0f-4872-8093-41852c5b07e5', description: 'Added the permanentDelete method to the mailSearchFolder resource.' },

  { name: 'Microsoft Graph Changelog', workload: 'Intune', when: 'August 19, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=92cb8a37-1a4e-4b9e-9d88-78acb5ec6de6', description: 'Removed the cloudPcSharedUseServicePlan resource and its supported methods. Going forward, use the cloudPcFrontLineServicePlan resource.' },
  { name: 'Microsoft Graph Changelog', workload: 'Intune', when: 'August 19, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=92cb8a37-1a4e-4b9e-9d88-78acb5ec6de6', description: 'Removed the sharedUseServicePlans relationship from the virtualEndpoint resource. Going forward, use the frontLineServicePlans relationship.' },

  { name: 'Microsoft Graph Changelog', workload: 'Teams', when: 'August 15, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=a84dbdaa-5da8-4544-8a10-22c0790a9c5e', description: 'Added the displayName property to the chatMessageReaction resource to represent the reaction name chatMessage.' },

  { name: 'Microsoft Graph Changelog', workload: 'Teams', when: 'August 8, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=d8f96b79-6370-407f-a68a-733b41652b9e', description: 'Added the settings property to the virtualEventTownhall resource.' },

  { name: 'Microsoft Graph Changelog', workload: 'Teams', when: 'August 6, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=ec5ee95e-0c0f-4fe5-a404-bdc4d3faea41', description: 'Added the virtualEventSettings resource type.' },
  { name: 'Microsoft Graph Changelog', workload: 'Teams', when: 'August 6, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=ec5ee95e-0c0f-4fe5-a404-bdc4d3faea41', description: 'Added the settings property to the virtualEvent resource.' },




  { name: 'Microsoft Graph Changelog', workload: 'Teams', when: 'July 22, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=eb4edef4-7167-4666-b00f-ca64a994ce69', description: 'Added the callId property to the callRecording resource.' },

  { name: 'Microsoft Graph Changelog', workload: 'Teams', when: 'July 22, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=eb4edef4-7167-4666-b00f-ca64a994ce69', description: 'Added the contentCorrelationId property to the callRecording resource.' },
  { name: 'Microsoft Graph Changelog', workload: 'Teams', when: 'July 22, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=eb4edef4-7167-4666-b00f-ca64a994ce69', description: 'Added the endDateTime property to the callRecording resource.' },
  { name: 'Microsoft Graph Changelog', workload: 'Teams', when: 'July 22, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=eb4edef4-7167-4666-b00f-ca64a994ce69', description: 'Added the callId property to the callTranscript resource.' },
  { name: 'Microsoft Graph Changelog', workload: 'Teams', when: 'July 22, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=eb4edef4-7167-4666-b00f-ca64a994ce69', description: 'Added the contentCorrelationId property to the callTranscript resource.' },
  { name: 'Microsoft Graph Changelog', workload: 'Teams', when: 'July 22, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=eb4edef4-7167-4666-b00f-ca64a994ce69', description: 'Added the endDateTime property to the callTranscript resource.' },

  { name: 'Microsoft Graph Changelog', workload: 'Entra ID', when: 'July 17, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=8a7c8eff-e942-4888-80b2-447a38615680', description: 'Added the photoUpdateSource enumeration type.' },
  { name: 'Microsoft Graph Changelog', workload: 'Entra ID', when: 'July 17, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=8a7c8eff-e942-4888-80b2-447a38615680', description: 'Added the photoUpdateSettings resource.' },
  { name: 'Microsoft Graph Changelog', workload: 'Entra ID', when: 'July 17, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=8a7c8eff-e942-4888-80b2-447a38615680', description: 'Added the photoUpdateSettings relationship to the admin resource.' },
  { name: 'Microsoft Graph Changelog', workload: 'Entra ID', when: 'July 17, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=8a7c8eff-e942-4888-80b2-447a38615680', description: 'Added the List method to the peopleAdminSettings resource.' },
  { name: 'Microsoft Graph Changelog', workload: 'Entra ID', when: 'July 17, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=8a7c8eff-e942-4888-80b2-447a38615680', description: 'Added the Create method to the peopleAdminSettings resource.' },
  { name: 'Microsoft Graph Changelog', workload: 'Entra ID', when: 'July 17, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=8a7c8eff-e942-4888-80b2-447a38615680', description: 'Added the Delete method to the peopleAdminSettings resource.' },

  { name: 'Microsoft Graph Changelog', workload: 'Entra ID', when: 'July 16, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=d9c722d5-7d5d-4d5d-8941-4e79bace02c4', description: 'Added the uriUsageType enumeration type.' },
  { name: 'Microsoft Graph Changelog', workload: 'Entra ID', when: 'July 16, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=d9c722d5-7d5d-4d5d-8941-4e79bace02c4', description: 'Added the configurationUri resource.' },
  { name: 'Microsoft Graph Changelog', workload: 'Entra ID', when: 'July 16, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=d9c722d5-7d5d-4d5d-8941-4e79bace02c4', description: 'Added the configurationUris property to the applicationTemplate resource.' },

  { name: 'Microsoft Graph Changelog', workload: 'Teams',    when: 'July 15, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=1cd89089-b655-489b-b893-8254a125ad74', description: 'Removed the meetingOrganizerId property from the callRecording resource.' },
  { name: 'Microsoft Graph Changelog', workload: 'Teams',    when: 'July 15, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=1cd89089-b655-489b-b893-8254a125ad74', description: 'Removed the meetingOrganizerId property from the callTranscript resource.' },
  { name: 'Microsoft Graph Changelog', workload: 'Entra ID', when: 'July 10, 2024', url: 'https://developer.microsoft.com/en-us/graph/changelog/?search=192ceafc-dd91-4a74-8daf-289025ca3dd8', description: 'Added the companyCode property to the companyDetail resource.' },
  // { name: 'DSC',        workload: '-',                       when: 'June 27, 2024', url: '', description: '' },
  // { name: 'DSC',        workload: '-',                       when: 'June 27, 2024', url: '', description: '' },
  // { name: 'DSC',        workload: '-',                       when: 'June 27, 2024', url: '', description: '' }
];




type WsResourceListPanelProps = {
  // mode:          string;
  // workloadName:  string;
  // workload: WsDeliverConfigWorkload;
  // workloadDataList: WsWorkloadData[];
  // resourcePanelVisible: string;

  schemaMappingList: WsDeliverConfigSchemaMapping[];

  // staticMappingList:    WsDeliverConfigSchemaMapping[]
  setStaticMappingList: React.Dispatch<React.SetStateAction<WsDeliverConfigSchemaMapping[] | undefined>>;

  resourcePanelVisible:    WsDeliverConfigSchemaItem;
  setResourcePanelVisible: React.Dispatch<React.SetStateAction<WsDeliverConfigSchemaItem | undefined>>;
};




const getMappingStatus = (props: WsResourceListPanelProps) => {

  const findMappingItem = props.schemaMappingList.find((item) => item.sourcePath === props.resourcePanelVisible.schemaPath);

    if (findMappingItem) {
      return findMappingItem.status;
    } else {
      return WsDeliverConfigSchemaMappingStatus.Review;
    }
};


const getMappingTargetPath = (props: WsResourceListPanelProps) => {

  const findMappingItem = props.schemaMappingList.find((item) => item.sourcePath === props.resourcePanelVisible.schemaPath);

  if (findMappingItem) {
    return findMappingItem.targetPath;
  } else {
    return '';
  }
};


const getMappingComments = (props: WsResourceListPanelProps) => {

  const findMappingItem = props.schemaMappingList.find((item) => item.sourcePath === props.resourcePanelVisible.schemaPath);

  if (findMappingItem) {
    return findMappingItem.comments;
  } else {
    return '';
  }
};




const WsResourceListPanel = (props: WsResourceListPanelProps) => {

  const portalContext = useContext(WsDeliverPortalContext);

  const [ newStatus, setNewStatus ] = useState<WsDeliverConfigSchemaMappingStatus>(getMappingStatus(props));

  const [ newTargetPath, setNewTargetPath ] = useState<string>(getMappingTargetPath(props));

  const [ newComments, setNewComments ] = useState<string>(getMappingComments(props));



  useEffect(() => {

    setNewStatus(getMappingStatus(props));

    setNewTargetPath(getMappingTargetPath(props));

    setNewComments(getMappingComments(props));

  }, [ props.resourcePanelVisible ]);



  const mappingItem = props.schemaMappingList.find((item) => item.sourcePath === props.resourcePanelVisible.schemaPath);

  if (!mappingItem) {
    console.log('no schemaItem');
  }  



  return (
    <Panel
      customWidth="550px"
      isBlocking={false}
      isOpen={true}
      onDismiss={() => {
        props.setResourcePanelVisible(undefined);
      }}
      type={PanelType.custom}
      headerText={`${props.resourcePanelVisible.name}`}
    >
      <>



        {/* path */}

        <div style={{ wordBreak: 'break-all' }}>
          <br />
          <b>Path:</b><br />
          {props.resourcePanelVisible.schemaPath}
        </div>

        <br />



        {/* powershell command */}

        <div>

        {
            resourceTypeIsResource(props.resourcePanelVisible.type, true)
            &&
            <div>
              <b>PowerShell Command:</b><br />Get-{props.resourcePanelVisible.name}
              {
                props.resourcePanelVisible.schemaPath.startsWith('/PowerShell/PnP')
                ?
                <>
                  <IconButton
                    iconProps={{ iconName: 'OpenInNewTab' }}
                    // href={`https://learn.microsoft.com/en-us/powershell/module/${getMsDocType(configSchemaItem.name, props.workload)}/get-${configSchemaItem.name.toLowerCase()}${getMsDocView(props.workload)}`}
                    // href={`https://learn.microsoft.com/en-gb/search/?terms="Get-${props.resourcePanelVisible.name}"`}
                    // href={`https://learn.microsoft.com/en-us/powershell/module/?term=Get-${props.resourcePanelVisible.name}`}
                    href={`https://pnp.github.io/powershell/cmdlets/Get-${props.resourcePanelVisible.name}.html`}
                    target="_blank"
                  />
                  <IconButton
                    iconProps={{ iconName: 'Search' }}
                    // href={`https://learn.microsoft.com/en-gb/search/?terms="Set-${props.resourcePanelVisible.name}"%20"Add-${props.resourcePanelVisible.name}"`}
                    // href={`https://learn.microsoft.com/en-us/powershell/module/?term=${props.resourcePanelVisible.name}`}
                    href="https://pnp.github.io/powershell/cmdlets/index.html"
                    target="_blank"
                  />
                </>
                :
                <>
                  <IconButton
                    iconProps={{ iconName: 'OpenInNewTab' }}
                    // href={`https://learn.microsoft.com/en-us/powershell/module/${getMsDocType(configSchemaItem.name, props.workload)}/get-${configSchemaItem.name.toLowerCase()}${getMsDocView(props.workload)}`}
                    // href={`https://learn.microsoft.com/en-gb/search/?terms="Get-${props.resourcePanelVisible.name}"`}
                    href={`https://learn.microsoft.com/en-us/powershell/module/?term=Get-${props.resourcePanelVisible.name}`}
                    target="_blank"
                  />
                  <IconButton
                    iconProps={{ iconName: 'Search' }}
                    // href={`https://learn.microsoft.com/en-gb/search/?terms="Set-${props.resourcePanelVisible.name}"%20"Add-${props.resourcePanelVisible.name}"`}
                    href={`https://learn.microsoft.com/en-us/powershell/module/?term=${props.resourcePanelVisible.name}`}
                    target="_blank"
                  />
                </>
              }
              <br />
              <br />
            </div>
          }



          {/* mapping status */}

          <div>
            <b>Status:</b>

            <Dropdown
              options={[
                { key: WsDeliverConfigSchemaMappingStatus.Review,   text: 'In Review' },
                { key: WsDeliverConfigSchemaMappingStatus.Mapped,   text: 'Mapped'    },
                { key: WsDeliverConfigSchemaMappingStatus.ReadOnly, text: 'Read-Only' },
                { key: WsDeliverConfigSchemaMappingStatus.Ignore,   text: 'Ignore'    },
                { key: WsDeliverConfigSchemaMappingStatus.Missing,  text: 'Missing'   },
              ]}

              // disabled={true}

              onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
                if (option) {
                  setNewStatus(getSchemaMappingStatus(`${option.key}`));
                }
              }}

              selectedKey={ newStatus }
            />
          </div>

          <br />

          <div>
            <b>Status Type:</b><br />
            {
              (
                newStatus === WsDeliverConfigSchemaMappingStatus.Mapped
                ||
                newStatus === WsDeliverConfigSchemaMappingStatus.Missing
              )
              ?
              <>{ (
                mappingItem?.auto
                &&
                mappingItem.status === newStatus
              ) ? 'Auto Mapping' : 'Direct Mapping' }</>
              :
              <>{ (
                mappingItem?.auto
                &&
                mappingItem.status === newStatus
              ) ? 'Set by Parent' : 'Set Directly' }</>
            }
            
          </div>



          {/* dsc path */}

          {
            newStatus === WsDeliverConfigSchemaMappingStatus.Mapped
            &&
            <>
              <br />
              <b>DSC Path ({ mappingItem?.auto ? 'Auto Mapping' : 'Direct Mapping' }):</b>
              {
                (
                  mappingItem?.auto
                  &&
                  mappingItem.status === newStatus
                )
                ?
                <div>{mappingItem.targetPath}</div>
                :
                <TextField
                  multiline={true}
                  rows={5}
                  onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string): void => {
                    setNewTargetPath(newValue || '');
                  }}
                  value={newTargetPath}
                />
              }
            </>
          }



          {
            <>
              <br />
              <b>Comments ({ mappingItem?.auto ? 'From Parent' : 'Direct' }):</b>
              <TextField
                multiline={true}
                rows={5}
                onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string): void => {
                  setNewComments(newValue || '');
                }}
                value={newComments}
              />
            </>
          }



          {
            mappingItem
            &&
            <>
              <br />
              <PrimaryButton
                text="Save Changes"
                disabled={(
                  mappingItem.status === newStatus
                  &&
                  mappingItem.targetPath === newTargetPath
                  &&
                  mappingItem.comments === newComments
                )}
                onClick={async () => {

                  const resourceMappingResult = await apiPost(`/deliver/resource-mapping`, {
                    source:     'PowerShell',
                    sourcePath:  mappingItem.sourcePath,
                    targetPath:  newStatus === WsDeliverConfigSchemaMappingStatus.Mapped ? newTargetPath : '',
                    status:      newStatus,
                    comments:    newComments,
                    description: '',
                    createdBy:   (portalContext?.currentUser?.email || '').toLowerCase()
                  });

                  await loadMappingData(props.setStaticMappingList);

                  // const nextState = [ ...props.staticMappingList ];

                  // const findItem = nextState.find((item) => item.sourcePath === mappingItem.sourcePath);

                  // if (findItem) {

                  //   findItem.targetPath = newStatus === WsDeliverConfigSchemaMappingStatus.Mapped ? newTargetPath : '';
                  //   findItem.status     = newStatus;
                  //   findItem.comments   = newComments;

                  //   props.setStaticMappingList(nextState);

                  // } else {
                  //   console.log('mapping item not found!');
                  // }
                }}
              />
            </>
          }
          












          {/* {
            (
              schemaItem
              &&
              (
                schemaItem?.status === WsDeliverConfigSchemaMappingStatus.Missing
                ||
                schemaItem?.status === WsDeliverConfigSchemaMappingStatus.Ignore
                ||
                schemaItem?.status === WsDeliverConfigSchemaMappingStatus.ReadOnly
              )
              ?
              <>
                <b>Status: </b>

                <Dropdown
                  options={[
                    { key: WsDeliverConfigSchemaMappingStatus.Missing,  text: 'Missing' ,  selected: schemaItem?.status === WsDeliverConfigSchemaMappingStatus.Missing  },
                    { key: WsDeliverConfigSchemaMappingStatus.ReadOnly, text: 'Read Only', selected: schemaItem?.status === WsDeliverConfigSchemaMappingStatus.ReadOnly },
                    { key: WsDeliverConfigSchemaMappingStatus.Ignore,   text: 'Ignore' ,   selected: schemaItem?.status === WsDeliverConfigSchemaMappingStatus.Ignore   },
                  ]}
                  disabled={true}
                  // onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                  //   if (option) {
                  //     history.push(`/deliver/config/m365-normalization/${option.key}`);
                  //   }
                  // }}
                  // selectedKey={schemaItem?.status || ''}
                />
              </>
              :
              <>
                <b>Mapping:</b><br/>
                {schemaItem?.targetPath || ''}
              </>
            )
          } */}

          {/* {
            (
              !schemaItem
            ||
              schemaItem.status === WsDeliverConfigSchemaMappingStatus.Missing
            )
            &&
            <>  <br />
                <b>PowerShell Script (Write):</b>
                <TextField
                  value={''}
                  multiline={true}
                  rows={5}
                />
              </>
          } */}
        </div>


        {/* <table className="table is-fullwidth">
          <thead>
            <tr>
              <th>Resource</th>
              <th>Ref</th>
            </tr>
          </thead>
          <tbody>
            ...
          </tbody>
        </table> */}
      </>
    </Panel>
  );
};











const WsNormalizationItem = (props: {
  schemaMappingList: WsDeliverConfigSchemaMapping[];
  mappingVisible: boolean;
  configSchemaList: WsDeliverConfigSchemaItem[];
  configSchemaItem: WsDeliverConfigSchemaItem;
  index: number;

  expandedPaths: string[];
  setExpanded: (value: boolean) => void;

  resourcePanelVisible: WsDeliverConfigSchemaItem | undefined;
  setResourcePanelVisible: React.Dispatch<React.SetStateAction<WsDeliverConfigSchemaItem | undefined>>

}) => {

  const resourceHasChildren = props.configSchemaList.filter((item) => item.schemaPath.startsWith(props.configSchemaItem.schemaPath) && item.schemaPath !== props.configSchemaItem.schemaPath).length > 0;

  const resourceIsExpanded = props.expandedPaths.includes(props.configSchemaItem.schemaPath);



  // level

  let level = props.configSchemaItem.schemaPath.split('/').length - 4;

  if (level < 0) {
    level = 0;
  }



  // padding

  const paddingLeft = 9 + (level * 21);



  // render

  if (![ 'new' ].includes(props.configSchemaItem.workload)) {

    const classList = [ 'ws-config-resource-row', 'ws-mapping-row' ];

    let schemaMappingItem: WsDeliverConfigSchemaMapping | undefined;

    if (props.mappingVisible) {

      schemaMappingItem = props.schemaMappingList.find((item) => item.sourcePath === props.configSchemaItem.schemaPath);

      if (schemaMappingItem) {

        if (schemaMappingItem.status === WsDeliverConfigSchemaMappingStatus.Mapped) {
          classList.push('ws-schema-mapped');

        } else if (schemaMappingItem.status === WsDeliverConfigSchemaMappingStatus.Review) {
          classList.push('ws-schema-review');

        } else if (schemaMappingItem.status === WsDeliverConfigSchemaMappingStatus.Ignore) {
          classList.push('ws-schema-ignore');

        } else if (schemaMappingItem.status === WsDeliverConfigSchemaMappingStatus.ReadOnly) {
          classList.push('ws-schema-read-only');

        } else if (schemaMappingItem.status === WsDeliverConfigSchemaMappingStatus.Missing) {
          classList.push('ws-schema-missing');
        }

      } else {
        classList.push('ws-schema-not-mapped');
      }
    }

    // if (props.configSchemaItem.schemaPath.startsWith('/PowerShell/MgBetaDeviceManagementConfigurationPolicy/')) {
    //   console.log(props.configSchemaItem);
    // }

    if (props.resourcePanelVisible?.schemaPath === props.configSchemaItem.schemaPath) {
      classList.push('ws-selected-in-panel');
    }

    // mapping

    return (
      <Fragment>
        <tr className={classList.join(' ')}>

          {
            props.mappingVisible
            &&
            <>
              <td
                className="ws-deliver-normalization-schema-settings"
                data-column="settings"
              >
                <IconButton
                  iconProps={{ iconName: 'Settings' }}
                  onClick={() => {
                    props.setResourcePanelVisible(props.configSchemaItem)
                  }}
                />
                {
                  schemaMappingItem
                  &&
                  <>
                    {getSchemaMappingStatusName(schemaMappingItem.status)}
                  </>
                }
              </td>
              <td className="ws-deliver-normalization-schema-mapping">
                {
                  schemaMappingItem
                  &&
                  <>
                    {
                      schemaMappingItem.auto
                      ?
                      <></>
                      :
                      <Icon
                        className="ws-deliver-normalization-schema-mapping-icon"
                        iconName={'MiniLink'}
                      />
                    }
                  </>
                }
              </td>
              <td className="ws-deliver-normalization-schema-comments">
                {
                  schemaMappingItem?.comments
                  &&
                  <div className="ws-deliver-normalization-schema-comments-icon">
                    <TooltipHost
                      // directionalHint={DirectionalHint.bottomCenter}
                      content={schemaMappingItem.comments}
                      id={`ws-mapping-commments-tooltip-${schemaMappingItem.sourcePath}`}
                      className="ws-mapping-commments-tooltip"
                      calloutProps={{
                        className: 'ws-mapping-commments-tooltip-callout',
                        style: {
                          // width: '200px'
                        }
                      }}
                    >
                      <BiCommentDetail
                        aria-describedby={`ws-mapping-commments-tooltip-${schemaMappingItem.sourcePath}`}
                        style={{
                          fontSize: '16px',
                          verticalAlign: 'middle',
                          marginLeft: '5px',
                          marginTop: '-3px'
                        }}
                      />
                    </TooltipHost>
                  </div>
                }
              </td>
            </>
          }

          {
            resourceHasChildren
            ?
            <td
              className="ws-deliver-normalization-schema-name"
              data-column="name"
              style={{
                paddingLeft: `${paddingLeft + 21}px`
              }}
              onClick={() => {
                props.setExpanded(!resourceIsExpanded);
              }}
            >

              {
                resourceIsExpanded
                ?
                <>
                  <Icon
                    iconName={'CollapseContentSingle'}
                    className="ws-deliver-config-collapsed"
                    style={{ left: `${paddingLeft}px` }}
                  />
                </>
                :
                <>
                  <Icon
                    iconName={'ExploreContentSingle'}
                    className="ws-deliver-config-expanded"
                    style={{ left: `${paddingLeft}px` }}
                  />
                </>
              }
              {props.configSchemaItem.name}
            </td>
            :
            <td
              className="ws-deliver-normalization-schema-name"
              data-column="name"
              style={{
                paddingLeft: `${paddingLeft + 21}px`
              }}
            >
              {props.configSchemaItem.name}
            </td>
          }


          <td
            className="ws-deliver-normalization-schema-type"
            data-column="type"
          >
            {getConfigItemType(props.configSchemaItem)}
          </td>

          <td
            className="ws-deliver-normalization-schema-path"
            data-column="path"
          >
            {props.configSchemaItem.schemaPath}
          </td>

          

        </tr>
      </Fragment>
    );

  } else {

    // news

    return (
      <Fragment>
        <tr className="ws-config-resource-row">
  
          <td
            data-column="configResourceName"
            style={{ paddingLeft: `${0 + 21}px` }}
            onClick={() => {
              // props.setExpanded(!resourceIsExpanded);
            }}
          >
            {/* {props.configSchemaItem.name} */}
            MS Graph
          </td>
  
          <td data-column="new:workload">
            {newSources[props.index]?.workload}
          </td>

          <td data-column="new:when">
            {newSources[props.index]?.when}
          </td>
  
          <td data-column="description">
            {
              newSources[props.index]
              &&
              <>
                {
                  newSources[props.index]?.url
                  ?
                  <a href={newSources[props.index]?.url} target="_blank">{newSources[props.index]?.name}</a>
                  :
                  <>{newSources[props.index]?.name}</>
                }
                {
                  newSources[props.index]?.description
                  &&
                  <div className="ws-deliver-config-normalization-resource-description">{newSources[props.index]?.description}</div>
                }
              </>
            }
          </td>
  
          <td data-column="action">
            {
              [ 'new' ].includes(props.configSchemaItem.workload)
              &&
              <WsDeliverActionSelect />
            }
            {
              [ 'inactive' ].includes(props.configSchemaItem.workload)
              &&
              <WsDeliverActionSelect />
            }
          </td>
  
        </tr>
      </Fragment>
    );
  }
};






const loadMappingData = async (setStaticMappingList: React.Dispatch<React.SetStateAction<WsDeliverConfigSchemaMapping[] | undefined>>) => {

  const mappingListResult = await apiGet(`/deliver/resource-mapping`);

  if (mappingListResult && Array.isArray(mappingListResult)) {
    const mappingListData = mappingListResult as WsDeliverConfigSchemaMapping[];
    const sortedMappingList = sortMappingList(mappingListData);
    // console.log(sortedMappingList);
    setStaticMappingList(sortedMappingList);
  }
};




const WsConfigNormalization = (props: {}) => {

  // const params: { tenantType: string, tenantId: string } = useParams();

  const history = useHistory();

  const params: { workload?: string } = useParams();



  // state

  // const [ workload, setWorkload ] = useState<string>(process.env.NODE_ENV === 'development' ? 'entraid' : 'new');

  const [ dscSchemaList, setDscSchemaList ] = useState<WsDeliverConfigSchemaItem[] | undefined>(undefined);

  const [ powershellSchemaList, setPowershellSchemaList ] = useState<WsDeliverConfigSchemaItem[] | undefined>(undefined);

  const [ staticMappingList, setStaticMappingList ] = useState<WsDeliverConfigSchemaMapping[] | undefined>(undefined);

  const [ dataType, setDataType ] = useState<string>('dsc');

  const [ emptyFieldsVisible, setEmptyFieldsVisible ] = useState<boolean>(true);

  const [ resourcePanelVisible, setResourcePanelVisible ] = useState<WsDeliverConfigSchemaItem | undefined>(undefined);



  // expanded paths

  const [ expandedPaths, setExpandedPaths ] = useState<string[]>([ '/DSC/', '/PowerShell/' ]);

  useEffect(() => {
    // console.log(expandedPaths);
  }, [ expandedPaths ]);



  // load data

  useEffect(() => {

    if (typeof params.workload === 'undefined' || params.workload === 'new') {
      setDataType('dsc');
    }

    const workload = params.workload || 'new';

    setDscSchemaList(undefined);
    setPowershellSchemaList(undefined);

    setTimeout(async () => {

      // schema list - dsc

      const dscResult = await apiGet(`/deliver/01903a3d-9408-7684-8552-c2258b002acb/${workload.toLowerCase()}/resource-schema`);

      if (dscResult && Array.isArray(dscResult)) {
        const dscData = dscResult as WsDeliverConfigSchemaItem[];
        // console.log(dscData);
        setDscSchemaList(dscData);
      }

      // schema list - powershell

      const powerShellResult = await apiGet(`/deliver/01903a3d-9408-7684-8552-c2258b002acb/${workload.toLowerCase()}/resource-schema?type=powershell`);

      if (powerShellResult && Array.isArray(powerShellResult)) {
        const powerShellData = powerShellResult as WsDeliverConfigSchemaItem[];
        // console.log(powerShellData);
        const filterResourceTypeIsResource = powerShellData.filter((item) => resourceTypeIsResource(item.type));
        console.log(`resources : ${filterResourceTypeIsResource.length}`);
        setPowershellSchemaList(powerShellData);
      }

      // mapping list

      await loadMappingData(setStaticMappingList);

    }, 200);

  }, [ params.workload ]);



  // render

  if (dscSchemaList && powershellSchemaList && staticMappingList) {



    const schemaMappingList = getSchemaMappingList(powershellSchemaList, dscSchemaList, staticMappingList);



    const configSchemaList = dataType === 'powershell' ? powershellSchemaList : dscSchemaList;



    // rows

    const rowElements: JSX.Element[] = [];

    configSchemaList.forEach((configSchemaItem: WsDeliverConfigSchemaItem, index: number) => {

      const resourcePath = configSchemaItem.schemaPath;

      const resourceParentPath = getParentPath(resourcePath); // const resourceParentPath = resourcePath.replace(`${encodeResourceName(configSchemaItem.name)}/`, '');

      if (expandedPaths.includes(resourceParentPath) || [ 'new' ].includes(params.workload || 'new')) {

        rowElements.push(
          <Fragment key={`ws-config-item-${index}`}>
            <WsNormalizationItem
              schemaMappingList={schemaMappingList}
              mappingVisible={dataType === 'powershell' ? true : false}
              configSchemaList={configSchemaList}
              configSchemaItem={configSchemaItem}
              index={index}

              expandedPaths={expandedPaths}
              setExpanded={(value: boolean) => {
                let nextExpandedPaths = [ ...expandedPaths ];

                if (value) {
                  nextExpandedPaths.push(resourcePath);
                } else {
                  nextExpandedPaths = nextExpandedPaths.filter((item) => !item.startsWith(resourcePath));
                }

                setExpandedPaths(nextExpandedPaths);
              }}

              resourcePanelVisible={resourcePanelVisible}
              setResourcePanelVisible={setResourcePanelVisible}
            />
          </Fragment>
        );
      }
    });



    // class list

    const classList = [ 'ws-deliver-normalization-page ws-deliver-tenant-list' ];

    if ([ 'new' ].includes(params.workload || '')) {
      classList.push('ws-deliver-normalization-new');
    }



    // render

    return (
      <div className={classList.join(' ')}>

        <div className="ws-deliver-config-header">

          {/* <Text key={'ws-sales-clients'} variant={'xLarge'} nowrap block>
            {`Normalization`}
          </Text> */}

          {
            typeof params.workload !== 'undefined'
            &&
            params.workload !== 'new'
            &&
            <>
              <div className="ws-deliver-config-header-options">

                <ActionButton
                  // label="Expand All"
                  iconProps={{ iconName: 'ExploreContentSingle' }}
                  onClick={() => {
                    const nextExpandedPaths = [ '/DSC/', '/PowerShell/' ];

                    configSchemaList.forEach((configSchemaItem: WsDeliverConfigSchemaItem) => {

                      const resourcePath = configSchemaItem.schemaPath;

                      const resourceParentPath = getParentPath(resourcePath);

                      nextExpandedPaths.push(resourceParentPath);

                    });

                    setExpandedPaths(nextExpandedPaths);
                  }}
                >
                  Expand All
                </ActionButton>

                <ActionButton
                  // label="Collapse All"
                  iconProps={{ iconName: 'CollapseContentSingle' }}
                  onClick={() => {
                    setExpandedPaths([ '/DSC/', '/PowerShell/' ]);
                  }}
                >
                  Collapse All
                </ActionButton>

                {/* <ActionButton
                  className="ws-deliver-config-header-add-resource"
                  iconProps={{ iconName: 'Add' }}
                  onClick={() => {
                    // setNewTenantDialogVisible(true);
                  }}
                >
                  Add Resource
                </ActionButton> */}
              </div>
              {
                dataType === 'powershell'
                &&
                <div className="ws-deliver-coverage-legend">
                  {/* <div className="ws-deliver-coverage-legend-item ws-managed">Managed (DSC Core)</div>
                  <div className="ws-deliver-coverage-legend-item ws-managed">Managed (Custom)</div> */}
                  <div className="ws-deliver-coverage-legend-item ws-review">In Review</div>
                  <div className="ws-deliver-coverage-legend-item ws-mapped">Mapped</div>
                  <div className="ws-deliver-coverage-legend-item ws-readonly">Read-Only</div>
                  <div className="ws-deliver-coverage-legend-item ws-ignore">Ignore</div>
                  <div className="ws-deliver-coverage-legend-item ws-gap">Missing</div>
                </div>
              }
              <WsConfigDataType
                page="normalization"
                emptyFieldsVisible={emptyFieldsVisible}
                setEmptyFieldsVisible={setEmptyFieldsVisible}
                dataType={dataType}
                setDataType={setDataType}
              />
            </>
          }

          <div className="ws-deliver-config-header-options ws-deliver-config-header-options-right">

            <Dropdown
              // label={props.label}
              options={[

                { key: 'new',            text: 'Updates Pending (18)'    },

                // { key: 'inactive',       text: 'Inactive Resources (12)' },

                { key: 'divider-1',      text: '-',                      itemType: SelectableOptionMenuItemType.Divider },

                { key: 'header-1',       text: 'Active Resources',       itemType: SelectableOptionMenuItemType.Header  },
                // { key: 'entraid',       text: 'Microsoft Entra ID'   },
                // { key: 'exchange',       text: 'Microsoft Exchange'   },
                // { key: 'intune',         text: 'Microsoft Intune'     },
                // { key: 'sharepoint',     text: 'Microsoft SharePoint' },
                // { key: 'teams',          text: 'Microsoft Teams'      },
                // // { key: 'office',        text: 'Office 365' },
                // { key: 'onedrive',       text: 'Microsoft OneDrive'},
                // // { key: 'onenote',        text: 'OneNote'},
                // // { key: 'power-platform', text: 'Power Platform'},
                // { key: 'securitycompliance', text: 'Security & Compliance' }

                { key: 'entraid',            text: 'Microsoft Entra ID'       },
                { key: 'exchange',           text: 'Microsoft Exchange'       },
                { key: 'intune',             text: 'Microsoft Intune'         },
                { key: 'onedrive',           text: 'Microsoft OneDrive'       },
                { key: 'planner',            text: 'Microsoft Planner'        },
                { key: 'powerplatform',      text: 'Microsoft Power Platform' },
                { key: 'sharepoint',         text: 'Microsoft SharePoint'     },
                { key: 'teams',              text: 'Microsoft Teams'          },
                { key: 'office365',          text: 'Office 365'               },
                { key: 'securitycompliance', text: 'Security & Compliance'    },
              ]}
              onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                if (option) {
                  history.push(`/deliver/config/m365-normalization/${option.key}`);
                }
              }}
              selectedKey={params.workload || 'new'}
            />

          </div>

        </div>

        <table className="table is-hoverable is-fullwidth ws-deliver-normalization-list">
          <thead>

            {
              ![ 'new', 'inactive' ].includes(params.workload || 'new')
              &&
              <tr>
                
                {
                  dataType === 'powershell'
                  &&
                  <>
                    <th className="ws-deliver-normalization-schema-settings">Status</th>
                    <th className="ws-deliver-normalization-schema-mapping"></th>
                    <th className="ws-deliver-normalization-schema-comments"></th>
                  </>
                }
                <th className="ws-deliver-normalization-schema-name" style={{ paddingLeft: '30px' }}>Name</th>
                <th className="ws-deliver-normalization-schema-type">Type</th>
                <th className="ws-deliver-normalization-schema-path">Path</th>
                
              </tr>
            }

            {
              [ 'new' ].includes(params.workload || 'new')
              &&
              <tr>
                <th>Resource</th>
                <th>Workload</th>
                <th>Date</th>
                <th>Source</th>
                <th></th>

              </tr>
            }

            {
              [ 'inactive' ].includes(params.workload || 'new')
              &&
              <tr>
                <th>Resource</th>
                <th></th>
                <th></th>
              </tr>
            }

          </thead>
          <tbody>
            {rowElements}
          </tbody>
        </table>

        {
          resourcePanelVisible
          &&
          <WsResourceListPanel
            schemaMappingList={schemaMappingList}
            // staticMappingList={staticMappingList}
            setStaticMappingList={setStaticMappingList}
            resourcePanelVisible={resourcePanelVisible}
            setResourcePanelVisible={setResourcePanelVisible}
          />
        }
      </div>
    );

  } else {
    return (<Loading />);
  }
};











export {
  WsConfigNormalization
};
